module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_RaceGamePromo_03.e260392e.jpg";